<template>
    <div class="w-100">
        <div class="d-flex justify-content-center h-50 align-items-center" v-if="$store.state.loading">
            <b-spinner variant="info" style="width: 7rem; height: 7rem;"/>
        </div>
        <div v-show="!$store.state.loading">
            <b-form class="user-multiple-form needs-validation"
                    validate
                    @submit.prevent="validateData('profile-form', updateProfileData)"
                    data-vv-scope="profile-form">
                <div class="user-multiple-form__row">
                    <b-row align-v="end">
                        <b-col md="4">
                            <b-form-group
                                label="First Name *"
                                label-for="first_name">
                                <b-form-input
                                    v-model="profile.firstName"
                                    type="text"
                                    id="first_name"
                                    name="first_name"
                                    v-validate="'required'"
                                    :class="{'is-valid': profile.firstName.length > 0,
                                 'is-invalid': errors.has('profile-form.first_name') }"
                                    required/>
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group
                                label="Last Name *"
                                label-for="last_name">
                                <b-form-input
                                    v-model="profile.lastName"
                                    type="text"
                                    id="last_name"
                                    name="last_name"
                                    v-validate="'required'"
                                    :class="{'is-valid': profile.lastName.length > 0,
                                'is-invalid': errors.has('profile-form.last_name') }"
                                    required/>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </div>
                <div class="user-multiple-form__row">
                    <b-row align-v="end" class="mb-4">
                        <b-col md="4">
                            <b-form-group
                                label="Phone *"
                                label-for="phone">
                                <b-form-input
                                    v-model="profile.phone"
                                    type="tel"
                                    id="phone"
                                    name="phone"
                                    v-validate="{required: true, regex:/^\+(?:[0-9] ?){6,14}[0-9]$/ }"
                                    :class="{'is-valid': !errors.has('profile-form.phone') && profile.phone !== '',
                                             'is-invalid': errors.has('profile-form.phone') }"
                                    required/>
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group
                                label="Email *"
                                label-for="email">
                                <b-form-input
                                    v-model="profile.email"
                                    type="email"
                                    id="email"
                                    name="email"
                                    v-validate="'required|email'"
                                    :class="{'is-valid': profile.email.length > 0,
                                             'is-invalid': errors.has('profile-form.email') }"
                                    required/>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row align-v="end">
                        <b-col md="4">
                            <b-form-group
                                label="Company name"
                                label-for="company_name">
                                <b-form-input
                                    v-model="profile.company.name"
                                    type="text"
                                    id="company_name"
                                    name="company_name"/>
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group
                                label="Company address"
                                label-for="company_address">
                                <b-form-input
                                    v-model="profile.company.address"
                                    type="text"
                                    id="company_address"
                                    name="company_address"/>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row align-v="end">
                        <b-col md="2">
                            <b-form-group
                                label="Company code"
                                label-for="company_code">
                                <b-form-input
                                    v-model="profile.company.code"
                                    type="text"
                                    id="company_code"
                                    name="company_code"/>
                            </b-form-group>
                        </b-col>
                        <b-col md="2">
                            <b-form-group
                                label="Company VAT"
                                label-for="company_VAT">
                                <b-form-input
                                    v-model="profile.company.VAT"
                                    type="text"
                                    id="company_VAT"
                                    name="company_VAT"
                                    v-validate="'min:2'"
                                    :class="{'is-valid': !errors.has('profile-form.company_VAT') && profile.company.VAT !== '',
                                    'is-invalid': errors.has('profile-form.company_VAT') }"
                                />
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group
                                label="Company url"
                                label-for="company_url">
                                <b-form-input
                                    v-model="profile.company.url"
                                    type="text"
                                    id="company_url"
                                    name="company_url"/>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-col cols="12">
                        <b-btn variant="primary-user"
                               class="mt-4"
                               :disabled="$store.state.loading"
                               type="submit">Save changes
                        </b-btn>
                    </b-col>
                </div>
            </b-form>
            <b-form class="user-multiple-form needs-validation pt-5"
                    data-vv-scope="password-form"
                    validate @submit.prevent="validateData('password-form', changePassword)">
                <div class="user-multiple-form__row align-items-center">
                    <b-row align-v="end">
                        <b-col md="4">
                            <div class="form-group">
                                <label for="password">Password change *</label>
                                <input id="password"
                                       type="password"
                                       name="password"
                                       v-model="password"
                                       v-validate="'required|min:6|max:32'"
                                       class="form-control"
                                       :class="{'is-invalid': errors.has('password-form.password') }"
                                       ref="password"
                                       required>
                            </div>
                        </b-col>
                        <b-col md="4">
                            <div class="form-group">
                                <label for="password_confirmation">Confirm password *</label>
                                <input id="password_confirmation"
                                       type="password"
                                       name="password_confirmation"
                                       v-validate="'required|confirmed:password'"
                                       class="form-control"
                                       :class="{'is-invalid': errors.has('password-form.password_confirmation')}"
                                       data-vv-as="password"
                                       ref="confirmPassword"
                                       required>
                            </div>
                        </b-col>
                    </b-row>
                    <b-col cols="12">
                        <b-btn variant="primary-user"
                               class="mt-4"
                               :disabled="$store.state.loading"
                               type="submit">Update password
                        </b-btn>
                    </b-col>
                </div>
            </b-form>
        </div>
    </div>
</template>

<script>
    import AddressSettings from '~cp/UserPanel/Elements/AddressSettings'

    export default {
        name: 'Profile',
        components: {
            AddressSettings,
        },
        data() {
            return {
                profile: {
                    firstName: '',
                    lastName: '',
                    address: '',
                    company: {
                        name: '',
                        address: '',
                        code: '',
                        VAT: '',
                        url: '',
                    },
                    phone: '',
                    email: '',
                },
                password: '',
            }
        },
        created() {
            this.getProfileData()
        },
        methods: {
            getProfileData() {
                this.$api('GET', this.$endpoints.profile).then(response => {
                    this.profile = {
                        firstName: response.firstName,
                        lastName: response.lastName,
                        address: response.address,
                        company: response.company,
                        phone: response.phone,
                        email: response.email,
                    }
                })
            },
            updateProfileData() {
                this.$api('PUT', this.$endpoints.profile, this.profile).then(() => {
                    this.$store.dispatch('globalAlertAction', {
                        type: 'success',
                        title: 'Profile data ',
                        message: 'succeed updated'
                    })
                })
            },
            changePassword() {
                this.$api('PATCH', this.$endpoints.password, {password: this.password}).then(() => {
                    this.password = ''
                    this.$refs.confirmPassword.value = ''
                    this.$store.dispatch('globalAlertAction', {
                        type: 'success',
                        title: 'Password updated!',
                    })
                    this.$validator.reset()
                })
            },
            validateData(scope, method) {
                this.$validator.validateAll(scope).then((result) => {
                    if (result) {
                        return this[method()]
                    } else {
                        console.log('error')
                    }
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/UserPanel/Pages/UserSettings/Profile.vue